import { Session } from '@app/models';
import { SESSION_HISTORY } from '@app/constants';
import { localStore } from '@app/helpers';

class SessionService {
    compareSession(session1: Session, session2: Session) {
        return session1.username?.toLowerCase() === session2.username?.toLowerCase();
    }

    sessionArrayCleanUp(array: Session[]) {
        const a = array.concat();

        for (let i = 0; i < a.length; ++i) {
            for (let j = i + 1; j < a.length; ++j) {
                if (this.compareSession(a[i], a[j])) {
                    a.splice(j--, 1);
                }
            }
        }

        return a;
    }

    getSessionHistory() {
        return JSON.parse(localStore.getItem(SESSION_HISTORY) ?? '[]');
    }

    isUserHaveSessions() {
        const sessions = this.getSessionHistory();
        return sessions.length > 0;
    }

    addSession(sessionList: Session[]): void {
        const previousSessions = this.getSessionHistory();

        let modifiedSessions = sessionList;

        const maxLength = 5;

        if (previousSessions) {
            modifiedSessions = this.sessionArrayCleanUp(
                previousSessions
                    .concat(sessionList)
                    .sort((a: Session, b: Session) => {
                        if (a.lastVisited > b.lastVisited) {
                            return -1;
                        } else if (a.lastVisited < b.lastVisited) {
                            return 1;
                        }
                        else {
                            return 0;
                        }
                    })
            );
        }

        while (modifiedSessions.length > maxLength) {
            modifiedSessions.pop();
        }

        try {
            localStore.setItem("session_history", JSON.stringify(modifiedSessions));
        } catch (e) {
            // TODO: Uncomment when we will set up dev variable
            // console.error(e);
        }
    }
}

export const sessionService = new SessionService();